import { useEffect, useState } from "react";
import { Select } from "@rio-cloud/rio-uikit";
import ErrorDialog from "../../../../../dialogs/ErrorDialog";
import SuccessDialog from "../../../../../dialogs/SuccessDialog";
import {
  Occurrence,
  OccurrenceDispatch,
} from "../../../../../../models/occurrence";
import { useDispatchForm } from "../../../../../../hooks/useDispatch";
import ChooseDealershipDialog from "./dialogs/chooseDealershipDialog";
import useAssets from "../../../../../../hooks/useAssets";

interface DispatchFormProps {
  occurrence?: Occurrence | null;
  addDispatch?: (
    occurrence: Occurrence,
    dispatch: OccurrenceDispatch
  ) => Promise<{
    wasCreated: boolean;
    error?: string;
    dispatch?: OccurrenceDispatch;
  }>;
  updateDispatchList: (dispatch: OccurrenceDispatch) => void;
  dispatches: OccurrenceDispatch[];
  persona?: "MANAGER" | "TOWER" | "CONSULTANT" | "PARTNERSHIP";
  clickedChassis: string | undefined;
}

const DispatchForm = (props: DispatchFormProps) => {
  const {
    optionsOccurrenceType,
    optionsPayer,
    optionsReleasePayment,
    loading,
    showErrorDialog,
    errorDialogBody,
    showSuccessDialog,
    dispatchForm,
    setDispatchForm,
    setShowErrorDialog,
    setShowSuccessDialog,
    handleAddDispatch,
    showChooseDealershipDialog,
    setShowChooseDealershipDialog,
  } = useDispatchForm(props);

  const { getAssets, getAssetIdByChassis } = useAssets();

  const [assetId, setAssetId] = useState<string | undefined>(undefined);

  useEffect(() => {
    getAssets().then(() => {
      const id = getAssetIdByChassis(props.clickedChassis ?? "");
      setAssetId(id);
    });
  }, [getAssets, getAssetIdByChassis, props.clickedChassis]);

  return (
    <>
      <div className="flex justify-between w-full gap-6 items-end my-6 p-6 pb-0 border rounded">
        <div className="form-group form-group-lg w-full">
          <label className="truncate">Tipo de ocorrência*</label>
          <Select
            id="1"
            placeholder="Selecione o tipo de ocorrência"
            options={optionsOccurrenceType}
            onChange={(value) =>
              setDispatchForm({ ...dispatchForm, occurrenceType: value?.id })
            }
          />
        </div>

        <div className="form-group form-group-lg w-full">
          <label className="truncate">Fonte pagadora*</label>
          <Select
            id="1"
            placeholder="Selecione"
            options={optionsPayer}
            onChange={(value) =>
              setDispatchForm({ ...dispatchForm, payer: value?.id })
            }
          />
        </div>

        <div className="form-group form-group-lg w-full">
          <label className="truncate">Liberar pagamento*</label>
          <Select
            id="1"
            placeholder="Selecione"
            options={optionsReleasePayment}
            onChange={(value) =>
              setDispatchForm({ ...dispatchForm, releasePayment: value?.id })
            }
          />
        </div>

        <div className="form-group form-group-lg w-full">
          <button
            className={`btn btn-lg btn-default w-full ${
              loading ? "btn-loading disabled" : ""
            }`}
            disabled={
              loading ||
              !dispatchForm.occurrenceType ||
              !dispatchForm.payer ||
              !dispatchForm.releasePayment
            }
            onClick={() => {
              setShowChooseDealershipDialog(true);
            }}
          >
            Atribuir novo acionamento
          </button>
        </div>
      </div>

      <ErrorDialog
        show={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title="Erro ao atribuir acionamento"
        body={errorDialogBody}
      />

      <SuccessDialog
        show={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        title="Acionamento atribuído com sucesso"
        body="O acionamento foi atribuído com sucesso."
      />

      <ChooseDealershipDialog
        show={showChooseDealershipDialog}
        onClose={() => setShowChooseDealershipDialog(false)}
        onChooseDealership={async (dn: string, route: string) => {
          setShowChooseDealershipDialog(false);
          await handleAddDispatch(dn, route);
        }}
        occurrenceType={dispatchForm.occurrenceType}
        assetId={assetId ?? ""}
      />
    </>
  );
};

export default DispatchForm;
